// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatMessageListSkeleton-moduleanswer__PWhmq";
var _2 = "GretaAIChatMessageListSkeleton-moduleanswerLine__zMzof Skeleton-moduleSkeleton__Mlrfv";
var _3 = "GretaAIChatMessageListSkeleton-modulequestion__RgNE_";
var _4 = "GretaAIChatMessageListSkeleton-modulequestionLine__nUSBm Skeleton-moduleSkeleton__Mlrfv";
var _5 = "GretaAIChatMessageListSkeleton-moduleskeleton__f0UkD";
var _6 = "GretaAIChatMessageListSkeleton-moduleturn__DIFcd";
export { _1 as "answer", _2 as "answerLine", _3 as "question", _4 as "questionLine", _5 as "skeleton", _6 as "turn" }
